var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bizs && _vm.bizs.length)?_c('div',{staticClass:"my-3 white"},[_c('v-container',[_c('div',{staticClass:"sl-title"},[_vm._v("Nearby Restaurants")]),_c('BizList',{attrs:{"bizs":_vm.bizs}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }